import { useMemo } from 'react';
import { IInflectTable } from 'models/InflectsModel';
import { IInflectIdName } from 'models/InflectTablesModel';

interface ITableHeaders {
  columnHeaders: IInflectIdName[];
  rowHeaders: IInflectIdName[];
  hasColumnHeaders: boolean;
}

export const useTableHeaders = (table: IInflectTable): ITableHeaders => {
  return useMemo(() => {
    const columnHeaders: IInflectIdName[] = [];
    const rowHeaders: IInflectIdName[] = [];
    const seenColumns = new Set<number>();
    const seenRows = new Set<number>();

    table.inflects.forEach((inflect) => {
      // Process column headers
      if (inflect.columnHeader && !seenColumns.has(inflect.column)) {
        seenColumns.add(inflect.column);
        columnHeaders.push(inflect.columnHeader);
      }

      // Process row headers
      if (inflect.rowHeader && !seenRows.has(inflect.row)) {
        seenRows.add(inflect.row);
        rowHeaders.push(inflect.rowHeader);
      }
    });

    const hasColumnHeaders = columnHeaders.length > 0;

    // Add empty header for corner cell if there are column headers
    if (hasColumnHeaders) {
      columnHeaders.unshift({ id: 0, name: '' });
    }

    return { columnHeaders, rowHeaders, hasColumnHeaders };
  }, [table.inflects]);
};
